import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import leaf from '../../assets/images/leaf.svg';
import Pagination from '../../components/Pagination';
import { formatDate } from '../../utils/formatDate';
import Button from '../../components/Button';
import QnaService from '../../api/service/member/QnaService';
import {
  QuestionData,
  QuestionsListData,
} from '../../api/service/QnaInterfaces';

const NoticeTabWrapper = styled.div``;

const NoticeHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
  img {
    width: 20px;
  }
`;

const TableContainer = styled.div`
  min-height: 481px;
  overflow-x: auto;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${(props) => props.theme.colors.whiteColor};
`;

const TableBox = styled.div`
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${(props) => props.theme.colors.whiteColor};
`;

const TableAdd = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: white;

  tr {
    border-bottom: 1px solid #ddd;
  }

  th,
  td {
    font-size: 16px;
    padding: 10px;
    text-align: center;
    vertical-align: middle; /* 세로 정렬 */
    white-space: nowrap; /* 줄바꿈 방지 */
  }

  th {
    width: 150px;
    background-color: #85c1a9;
    color: white;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;

    tr {
      border-bottom: 1px solid #ddd;
    }

    th,
    td {
      font-size: 12px;
      padding: 10px;
      text-align: center;
      vertical-align: middle; /* 세로 정렬 */
      white-space: nowrap; /* 줄바꿈 방지 */
    }

    th {
      width: 70px;
      font-weight: 400;
    }

    th:first-child {
      border-top-left-radius: 0px;
    }

    th:last-child {
      border-top-right-radius: 0px;
    }
  }
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: white;

  tr {
    border-bottom: 1px solid #ddd;
  }

  tr:nth-child(12) {
    border-bottom: none; /* 마지막 행의 border 제거 */
  }

  th,
  td {
    font-size: 16px;
    padding: 10px;
    text-align: center;
    vertical-align: middle; /* 세로 정렬 */
    white-space: nowrap; /* 줄바꿈 방지 */
  }

  th {
    background-color: #85c1a9;
    color: white;
    font-weight: 500;
  }

  th:first-child {
    border-top-left-radius: 10px;
  }

  th:last-child {
    border-top-right-radius: 10px;
  }

  /* 제목 열을 가장 넓게 설정 */
  th:nth-child(2),
  td:nth-child(2) {
    width: 50%; /* 제목 열의 폭을 설정 */
  }

  @media (max-width: 768px) {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;

    tr {
      border-bottom: 1px solid #ddd;
    }

    th,
    td {
      font-size: 12px;
      padding: 10px;
      text-align: center;
      vertical-align: middle; /* 세로 정렬 */
      white-space: nowrap; /* 줄바꿈 방지 */
    }

    th {
      font-weight: 400;
    }

    th:first-child {
      border-top-left-radius: 0px;
    }

    th:last-child {
      border-top-right-radius: 0px;
    }

    /* 제목 열 폭 조정 */
    th:nth-child(2),
    td:nth-child(2) {
      width: 40%; /* 모바일 환경에서의 폭 */
    }
  }
`;

const FormContainer = styled.div``;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 450px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  resize: none;
`;

const TableContent = styled.div<{ $isAnswers: boolean }>`
  white-space: pre-wrap; /* 줄바꿈과 공백 유지 */
  word-wrap: break-word; /* 단어 단위로 줄바꿈 */
  word-break: break-word; /* 긴 단어도 강제 줄바꿈 */
  padding: 10px;
  background-color: #ebf0ee;
  height: ${({ $isAnswers }) => ($isAnswers ? '280px' : '410px')};
  border-bottom: 2px dashed
    ${({ $isAnswers, theme }) =>
      $isAnswers ? `${theme.colors.subColor}` : '#fff'};
  overflow-y: auto;
`;

const TableAnswer = styled.div`
  padding: 10px;
  background-color: #ebf0ee;
  height: 200px;
  overflow-y: auto;
  p {
    padding-bottom: 10px;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;
const ButtonContainer2 = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
`;

function NoticeTab2() {
  const [permissions, setPermissions] = useState('');
  const [question, setQuestion] = useState<QuestionsListData[]>([]);
  const [selectedQuestions, setSelectedQuestions] =
    useState<QuestionData | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number>(0); //
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [showForm, setShowForm] = useState<boolean>(false); // 폼 표시 여부 상태
  const [authorName, setAuthorName] = useState<string>(''); // 작성자 이름 상태
  const [isEditing, setIsEditing] = useState<boolean>(false); // 수정 모드 상태
  const [formData, setFormData] = useState({ title: '', content: '' }); // 폼 데이터 상태

  const handleRowClick = async (index: number, questionId: string) => {
    try {
      const response = await QnaService.getQuestionDetail(questionId);
      setSelectedQuestions(response.data);
      setSelectedIndex(index);

      // URL 업데이트 (페이지 이동 없이)
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('questionId', questionId);
      window.history.pushState({}, '', currentUrl);
    } catch (error) {
      console.error('공지사항 상세 조회 실패:', error);
    }
  };

  const handleButtonClick = async () => {
    setSelectedQuestions(null); // 선택된 공지사항 데이터 저장

    // URL 초기화 (페이지 이동 없이)
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('questionId');
    window.history.pushState({}, '', currentUrl);
  };

  const handleAddButtonClick = () => {
    setShowForm(true);
    setIsEditing(false); // 추가 모드
    setFormData({ title: '', content: '' }); // 폼 데이터 초기화
  };

  const handleEditButtonClick = () => {
    if (selectedQuestions) {
      setShowForm(true);
      setIsEditing(true); // 수정 모드
      setFormData({
        title: selectedQuestions.title,
        content: selectedQuestions.content,
      });
    }
  };

  const handleFormSubmit = async () => {
    try {
      if (isEditing) {
        // 수정 모드
        await QnaService.updateQuestion(
          selectedQuestions?.questionId || '',
          formData
        );
        alert('문의가 성공적으로 수정되었습니다.');
      } else {
        // 추가 모드
        await QnaService.createQuestion(formData);
        alert('문의가 성공적으로 제출되었습니다.');
      }
      setShowForm(false);
      setFormData({ title: '', content: '' }); // 폼 데이터 초기화
      setSelectedQuestions(null); // 선택된 공지사항 데이터 저장
      fetchQna(currentPage); // 제출 후 목록 새로고침
    } catch (error) {
      console.error('문의 제출 실패:', error);
      alert(error);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchQna(page);
  };

  useEffect(() => {
    fetchQna(0);
    const name = localStorage.getItem('name') || '알 수 없음';
    setAuthorName(name);

    // URL에서 questionId 가져오기
    const urlParams = new URLSearchParams(window.location.search);
    const questionId = urlParams.get('questionId');

    const fetchPermissions = () => {
      const storedPermissions = localStorage.getItem('permissions') || 'BUYER'; // 기본값: BUYER
      setPermissions(storedPermissions);
      //console.log(storedPermissions);
    };
    fetchPermissions();

    if (questionId) {
      handleRowClick(0, questionId);
    }
  }, []);

  const fetchQna = async (currentPage: number) => {
    try {
      const response = await QnaService.getQuestionsList(currentPage, 12);
      setQuestion(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (err) {
      console.error(err);
      alert(err);
    }
  };

  const handleDeleteButtonClick = async () => {
    if (!selectedQuestions) return;

    const confirmDelete = window.confirm('정말로 삭제하시겠습니까?');
    if (!confirmDelete) return;

    try {
      await QnaService.deleteQuestion(selectedQuestions.questionId);
      alert('문의가 성공적으로 삭제되었습니다.');
      setSelectedQuestions(null); // 선택된 데이터 초기화
      fetchQna(currentPage); // 목록 새로고침
    } catch (error) {
      console.error('문의 삭제 실패:', error);
      alert(error);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <NoticeTabWrapper>
      <NoticeHeader>
        <img src={leaf} alt="leaf" />
        <h1>문의 게시판</h1>
      </NoticeHeader>
      {showForm ? (
        <FormContainer>
          <TableAdd>
            <tbody>
              <tr>
                <th>제목</th>
                <td>
                  <Input
                    type="text"
                    name="title"
                    placeholder="제목을 입력해 주세요"
                    value={formData.title}
                    onChange={handleChange}
                    style={{ width: '100%' }}
                  />
                </td>
              </tr>
              <tr>
                <th>문의내용</th>
                <td>
                  <TextArea
                    name="content"
                    placeholder="문의 내용을 입력해주세요"
                    value={formData.content}
                    onChange={handleChange}
                  />
                </td>
              </tr>
            </tbody>
          </TableAdd>
          <ButtonGroup>
            <Button save={true} onClick={handleFormSubmit}>
              {isEditing ? '수정하기' : '문의하기'}
            </Button>
            <Button
              onClick={() => {
                setShowForm(false);
                fetchQna(currentPage); // 제출 후 목록 새로고침
                setFormData({ title: '', content: '' }); // formData 초기화
              }}
            >
              취소
            </Button>
          </ButtonGroup>
        </FormContainer>
      ) : selectedQuestions ? (
        <>
          <TableContainer id="table-container">
            <TableBox>
              <Table>
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>제목</th>
                    <th>작성자</th>
                    <th>작성날짜</th>
                  </tr>
                </thead>
                <tbody>
                  <tr key={selectedQuestions.questionId}>
                    <td>{selectedIndex + 1}</td>

                    <td>
                      {selectedQuestions.title.length > 30
                        ? selectedQuestions.title.substring(0, 30) + '...'
                        : selectedQuestions.title}
                    </td>
                    <td>
                      {permissions === 'ADMIN'
                        ? selectedQuestions.memberInfo?.name
                        : authorName}
                    </td>
                    <td>{formatDate(selectedQuestions.regDate)}</td>
                  </tr>
                </tbody>
              </Table>
            </TableBox>
            <TableContent
              $isAnswers={
                Array.isArray(selectedQuestions.answers) &&
                selectedQuestions.answers.length > 0
              }
            >
              {selectedQuestions.content}
            </TableContent>
            {Array.isArray(selectedQuestions.answers) &&
              selectedQuestions.answers.length > 0 && (
                <TableAnswer>
                  {selectedQuestions.answers.map((answer) => (
                    <div
                      key={answer.answerId}
                      dangerouslySetInnerHTML={{
                        __html: answer.content.replace(/\n/g, '<br />'),
                      }}
                    />
                  ))}
                </TableAnswer>
              )}
          </TableContainer>
          <ButtonContainer>
            {permissions !== 'ADMIN' && (
              <div>
                {Array.isArray(selectedQuestions.answers) &&
                  selectedQuestions.answers.length === 0 && (
                    <Button
                      save={true}
                      onClick={handleEditButtonClick}
                      style={{ marginRight: 10 }}
                    >
                      수정하기
                    </Button>
                  )}
                <Button onClick={handleDeleteButtonClick}>삭제</Button>
              </div>
            )}
            <Button save={true} onClick={() => handleButtonClick()}>
              목록
            </Button>
          </ButtonContainer>
        </>
      ) : (
        <>
          <TableContainer>
            <TableBox>
              <Table>
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>제목</th>
                    <th>작성자</th>
                    <th>작성날짜</th>
                  </tr>
                </thead>
                <tbody>
                  {question.length === 0 && (
                    <tr>
                      <td colSpan={4}>문의 사항이 없습니다.</td>
                    </tr>
                  )}
                  {question.map((item, index) => (
                    <tr
                      key={item.questionId}
                      onClick={() => handleRowClick(index, item.questionId)}
                    >
                      <td>{index + 1}</td>
                      <td>
                        {item.title.length > 30
                          ? item.title.substring(0, 30) + '...'
                          : item.title}
                      </td>
                      <td>
                        {permissions === 'ADMIN'
                          ? item.memberInfo?.name
                          : authorName}
                      </td>
                      {/* ✅ 관리자면 "관리자"로 표시 */}
                      <td>{formatDate(item.regDate)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </TableBox>
          </TableContainer>
          {permissions !== 'ADMIN' && (
            <ButtonContainer2>
              <Button save={true} onClick={handleAddButtonClick}>
                문의하기
              </Button>
            </ButtonContainer2>
          )}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </NoticeTabWrapper>
  );
}

export default NoticeTab2;
